import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiEyeLine } from '@remixicon/react';

const entityPreviewPage = PageBlueprint.make({
  name: 'entity-preview',
  params: {
    path: '/entity-preview',
    title: 'Entity Preview',
    icon: <RiEyeLine />,
    loader: () =>
      import('./components/EntityPreviewPage').then(m => (
        <m.EntityPreviewPage />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'entity-preview',
  extensions: [entityPreviewPage],
});
